import { fetchAPI } from './fetchAPI';

// ==================== Datasets ====================

export const getDatasets = async (params: Record<string, any> = {}): Promise<any> => {
  const queryParams = new URLSearchParams();
  if (params.page) queryParams.append('page', params.page);
  if (params.limit) queryParams.append('limit', params.limit);
  if (params.isActive !== undefined) queryParams.append('is_active', params.isActive);

  const query = queryParams.toString();
  return fetchAPI(`/genaiops/datasets${query ? '?' + query : ''}`);
};

export const getDataset = async (datasetId: string): Promise<any> => {
  return fetchAPI(`/genaiops/datasets/${datasetId}`);
};

export const getDatasetVariables = async (datasetId: string): Promise<any> => {
  return fetchAPI(`/genaiops/datasets/${datasetId}/variables`);
};

// ==================== Dataset Import ====================

export const importDataset = async (data: Record<string, any>): Promise<any> => {
  return fetchAPI('/genaiops/datasets/import', {
    method: 'POST',
    body: JSON.stringify(data),
  });
};

export const uploadDatasetFile = async (formData: FormData): Promise<any> => {
  return fetchAPI('/genaiops/datasets/import/upload', {
    method: 'POST',
    body: formData,
    headers: {}, // Let browser set Content-Type for multipart
  });
};

export const previewImport = async (formData: FormData): Promise<any> => {
  return fetchAPI('/genaiops/datasets/import/preview', {
    method: 'POST',
    body: formData,
    headers: {},
  });
};

export const getImportJobs = async (params: Record<string, any> = {}): Promise<any> => {
  const queryParams = new URLSearchParams();
  if (params.page) queryParams.append('page', params.page);
  if (params.limit) queryParams.append('limit', params.limit);
  if (params.dataset_id) queryParams.append('dataset_id', params.dataset_id);
  const query = queryParams.toString();
  return fetchAPI(`/genaiops/datasets/import-jobs${query ? '?' + query : ''}`);
};

export const bulkDeleteDatasets = async (ids: string[]): Promise<any> => {
  return fetchAPI('/genaiops/datasets/bulk', {
    method: 'DELETE',
    body: JSON.stringify({ ids }),
  });
};

export const bulkDeleteImportJobs = async (ids: string[]): Promise<any> => {
  return fetchAPI('/genaiops/import-jobs/bulk', {
    method: 'DELETE',
    body: JSON.stringify({ ids }),
  });
};

export const assignGenAIOpsDatasetProject = async (datasetId: string, projectId: string | null): Promise<any> => {
  return fetchAPI(`/genaiops/datasets/${datasetId}`, {
    method: 'PATCH',
    body: JSON.stringify({ project_id: projectId }),
  });
};

export const assignGenAIOpsDatasetWorkload = async (datasetId: string, workloadId: string | null): Promise<any> => {
  return fetchAPI(`/genaiops/datasets/${datasetId}`, {
    method: 'PATCH',
    body: JSON.stringify({ workload_id: workloadId }),
  });
};

// ==================== Judge Rubrics ====================

export const getJudgeRubrics = async (params: Record<string, any> = {}): Promise<any> => {
  const queryParams = new URLSearchParams();
  if (params.page) queryParams.append('page', params.page);
  if (params.limit) queryParams.append('limit', params.limit);
  if (params.isActive !== undefined) queryParams.append('is_active', params.isActive);

  const query = queryParams.toString();
  return fetchAPI(`/genaiops/judge-rubrics${query ? '?' + query : ''}`);
};

export const getJudgeRubric = async (rubricId: string): Promise<any> => {
  return fetchAPI(`/genaiops/judge-rubrics/${rubricId}`);
};

export const createJudgeRubric = async (rubric: Record<string, any>): Promise<any> => {
  return fetchAPI('/genaiops/judge-rubrics', {
    method: 'POST',
    body: JSON.stringify(rubric),
  });
};

export const updateJudgeRubric = async (rubricId: string, updates: Record<string, any>): Promise<any> => {
  return fetchAPI(`/genaiops/judge-rubrics/${rubricId}`, {
    method: 'PUT',
    body: JSON.stringify(updates),
  });
};

export const deleteJudgeRubric = async (rubricId: string): Promise<any> => {
  return fetchAPI(`/genaiops/judge-rubrics/${rubricId}`, {
    method: 'DELETE',
  });
};

// Type exports
export interface CreateJudgeRubricData {
  name: string;
  description?: string;
  criteria: Record<string, unknown>[];
  [key: string]: unknown;
}
